import { LOCIZE_NAMESPACE } from 'main/common'
import { Tag } from 'main/ui'
import { philosophyColor, philosophyLabelTranslated } from 'main/util/profile'
import React from 'react'
import { useTranslation } from 'react-i18next'

function PhilosophyTag(props: { philosophy: string }) {
  const { philosophy } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    (philosophy !== 'hidden' && (
      <Tag color={philosophyColor(philosophy)}>{philosophyLabelTranslated(philosophy, t)}</Tag>
    )) || <></>
  )
}

export default React.memo(PhilosophyTag)
